import { RealtimeRepository } from "@api/repositories/reatime-repository/RealtimeRepository";
import { ObserverMethods, Observers } from "@api/repositories/reatime-repository/types";
import { ObserverMethodsType } from "../types/ObserverMethodsType"


export interface SignalRHelperinterface {
    connectToHub(observerMethods: Record<ObserverMethodsType, ObserverMethods>): Promise<void>;
    disconnectFromHub(): Promise<void>;
}

export class SignalRHelper implements SignalRHelperinterface {

    private realTimeObservers: Observers;

    constructor(
        private readonly realtimeRepository: RealtimeRepository,
        private readonly lang: string
    ) {

    }

    private get scheduleChanelName() {
        return `objects.MeetingsSchedule.${this.lang}`;
    }

    private get slotChannelName() {
        return `objects.MeetingsScheduleSlot.${this.lang}`;
    }

    async connectToHub(observerMethods: Record<ObserverMethodsType, ObserverMethods>) {

        this.realTimeObservers = {
            [this.scheduleChanelName]: observerMethods[ObserverMethodsType.schedule],
            [this.slotChannelName]: observerMethods[ObserverMethodsType.slot]
        }

        this.realtimeRepository.attach(this.realTimeObservers)
    }

    async disconnectFromHub() {
        this.realtimeRepository.detach(this.realTimeObservers)
    }
}